module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/车1.9403b6b8.png";